module.exports = "https://static.im-cdn.com/mjc/storefront/Bright/static/media/emptyCart.714fac3f.svg";